var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "affiliateScheduleModal",
        maximized: _vm.currentStep === "review",
        value: _vm.affiliateScheduleModal
      },
      on: {
        hide: function($event) {
          _vm.closeModal("affiliateSchedule")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-certificate" } }),
                  _vm._v(" Affiliate Schedule Report\n      ")
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("affiliateSchedule")
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-stepper",
            {
              ref: "stepper",
              attrs: { "no-header-navigation": "" },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "q-step",
                { attrs: { name: "start", title: "Start", order: "1" } },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "sl-row" }, [
                        _c("div", { staticClass: "sl-col-12" }, [
                          _c(
                            "p",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                "max-width": "350px",
                                margin: "0 auto"
                              }
                            },
                            [
                              _vm._v(
                                "This report shows all affiliate schedules for a given date range."
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "q-step",
                {
                  attrs: {
                    name: "course",
                    order: "2",
                    title: "Pick a course",
                    "done-icon": "check",
                    subtitle: ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "sl-row sl-vp" }, [
                        _c("div", { staticClass: "sl-col-12 q-pb-lg" }, [
                          _c(
                            "p",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                "max-width": "350px",
                                margin: "0 auto"
                              }
                            },
                            [_vm._v("Select a course.")]
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "sl-col-12" },
                          [
                            _c("q-select", {
                              attrs: {
                                clearable: "",
                                options: _vm.courseOptions,
                                value: _vm.affiliateScheduleForm.COURSE_ID
                              },
                              on: {
                                input: function(value) {
                                  return _vm.changeState({
                                    area: "affiliateScheduleForm",
                                    field: "COURSE_ID",
                                    val: value
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "q-step",
                { attrs: { name: "date", title: "Date Range", order: "3" } },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "sl-row sl-vp" }, [
                        _c("div", { staticClass: "sl-col-12" }, [
                          _c(
                            "p",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                "max-width": "350px",
                                margin: "0 auto"
                              }
                            },
                            [_vm._v("Choose a date range.")]
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "sl-col-6" },
                          [
                            _c("q-datetime", {
                              attrs: {
                                "stack-label": "Start Date",
                                value: _vm.affiliateScheduleForm.START_DATE
                              },
                              on: {
                                change: function(val) {
                                  return _vm.changeState({
                                    area: "affiliateScheduleForm",
                                    field: "START_DATE",
                                    val: val
                                  })
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-6" },
                          [
                            _c("q-datetime", {
                              attrs: {
                                "stack-label": "End Date",
                                value: _vm.affiliateScheduleForm.END_DATE
                              },
                              on: {
                                change: function(val) {
                                  return _vm.changeState({
                                    area: "affiliateScheduleForm",
                                    field: "END_DATE",
                                    val: val
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "q-step",
                {
                  attrs: {
                    name: "agencies",
                    title: "Select Affiliates",
                    order: "4"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "sl-row sl-vp" }, [
                        _c("div", { staticClass: "sl-col-12 q-pb-lg" }, [
                          _c(
                            "p",
                            {
                              staticClass: "text-center",
                              staticStyle: {
                                "max-width": "350px",
                                margin: "0 auto"
                              }
                            },
                            [_vm._v("Select affiliates.")]
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "sl-col-12" },
                          [
                            _c(
                              "q-chips-input",
                              {
                                attrs: {
                                  placeholder: "Start typing an affiliate"
                                },
                                model: {
                                  value: _vm.affiliates,
                                  callback: function($$v) {
                                    _vm.affiliates = $$v
                                  },
                                  expression: "affiliates"
                                }
                              },
                              [
                                _c("q-autocomplete", {
                                  attrs: {
                                    "max-results": 30,
                                    "value-field": "label"
                                  },
                                  on: { search: _vm.searchAffiliates }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _vm.currentStep === "review" && _vm.selectedSchedules.length > 0
                ? _c("q-btn", {
                    attrs: {
                      color: "red",
                      icon: "fa fa-trash",
                      label: "Remove Selected"
                    },
                    on: {
                      click: function($event) {
                        _vm.removeSelectedSchedules()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n      "),
              _c("q-toolbar-title"),
              _vm.currentStep !== "start"
                ? _c("q-btn", {
                    attrs: { color: "primary", flat: "", label: "Back" },
                    on: {
                      click: function($event) {
                        _vm.$refs.stepper.previous()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.currentStep !== "agencies" &&
                      _vm.currentStep !== "review",
                    expression:
                      "currentStep !== 'agencies' && currentStep !== 'review'"
                  }
                ],
                staticClass: "q-mx-md",
                attrs: { flat: "", color: "primary", label: "Next" },
                on: {
                  click: function($event) {
                    _vm.$refs.stepper.next()
                  }
                }
              }),
              _vm.currentStep === "agencies"
                ? _c("q-btn", {
                    attrs: {
                      color: "green",
                      icon: "fa fa-gear",
                      label: "Run",
                      loading: _vm.loading
                    },
                    on: {
                      click: function($event) {
                        _vm.runReport()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                on: {
                  click: function($event) {
                    _vm.closeModal("affiliateSchedule")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }